export const UNKNOWN_SOFTWARE_VERSION = 'Unknown Software Version';
export const UNKNOWN_IMAGE_VERSION = 'Unknown Image Version';

const normalizeVersion = (
  value: string | null | undefined,
  unknownVersion: string,
  unknownAliases: readonly string[]
): string => {
  const normalized = String(value ?? '').trim();
  const lowerCaseValue = normalized.toLowerCase();

  if (!normalized || lowerCaseValue === 'null' || unknownAliases.includes(lowerCaseValue)) {
    return unknownVersion;
  }

  return normalized;
};

export const normalizeSoftwareVersion = (value: string | null | undefined): string =>
  normalizeVersion(value, UNKNOWN_SOFTWARE_VERSION, [
    'unknown',
    'unknown software',
    'unknown software version',
  ]);

export const normalizeImageVersion = (value: string | null | undefined): string =>
  normalizeVersion(value, UNKNOWN_IMAGE_VERSION, [
    'unknown',
    'unknown image',
    'unknown image version',
  ]);
